module.exports = __webpack_public_path__ + "60e859da4b531c57ef3c6ce21bfc530a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/060.jpg
// module id = 60
// module chunks = 0